import { render, staticRenderFns } from "./myOrderPage.vue?vue&type=template&id=16ebb15e&scoped=true&"
import script from "./myOrderPage.vue?vue&type=script&lang=ts&"
export * from "./myOrderPage.vue?vue&type=script&lang=ts&"
import style0 from "./myOrderPage.vue?vue&type=style&index=0&id=16ebb15e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ebb15e",
  null
  
)

export default component.exports